var data = {
	"body": "<g class=\"icon-tabler\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2\"/><path d=\"M7 11l5 5l5-5\"/><path d=\"M12 4v12\"/></g>",
	"width": 24,
	"height": 24
};
export default data;
